export default __webpack_public_path__ + "static/media/nft.0725a620.mp4";